import React from 'react';

/**
 * Premium skeleton — shown while a route is being lazy-loaded.
 * Mimics a typical Eager page (navbar offset + hero + cards) so users see
 * structure instead of blank screen.
 */
export default function RouteSkeleton() {
    return (
        <div className="min-h-screen bg-slate-50 pt-24 pb-20 px-4 sm:px-6 lg:px-8" data-testid="route-skeleton">
            <div className="max-w-6xl mx-auto animate-pulse">
                {/* Hero */}
                <div className="grid md:grid-cols-2 gap-8 mb-10">
                    <div className="space-y-4">
                        <div className="h-4 w-24 bg-slate-200 rounded-full" />
                        <div className="h-12 w-5/6 bg-slate-200 rounded-xl" />
                        <div className="h-12 w-2/3 bg-slate-200 rounded-xl" />
                        <div className="h-4 w-full bg-slate-100 rounded-md mt-6" />
                        <div className="h-4 w-5/6 bg-slate-100 rounded-md" />
                        <div className="h-4 w-3/4 bg-slate-100 rounded-md" />
                        <div className="flex gap-3 mt-6">
                            <div className="h-12 w-40 bg-slate-200 rounded-2xl" />
                            <div className="h-12 w-32 bg-slate-100 rounded-2xl" />
                        </div>
                    </div>
                    <div className="hidden md:block aspect-[4/3] bg-slate-200 rounded-3xl" />
                </div>
                {/* Cards row */}
                <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
                    {Array.from({ length: 6 }).map((_, i) => (
                        <div
                            key={i}
                            className="bg-white border border-slate-100 rounded-2xl p-5 space-y-3"
                            style={{ opacity: 1 - i * 0.07 }}
                        >
                            <div className="h-32 bg-slate-100 rounded-xl" />
                            <div className="h-4 w-3/4 bg-slate-200 rounded-md" />
                            <div className="h-3 w-1/2 bg-slate-100 rounded-md" />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
